import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useServerFn } from "@tanstack/react-start";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { createSource } from "@/lib/admin-sources.functions";
import { sourceInputSchema } from "@/lib/admin-sources.schemas";
import { SourceForm } from "@/components/admin/SourceForm";

export const Route = createFileRoute("/_authenticated/_admin/admin/sources/new")({
  component: NewSourcePage,
});

function NewSourcePage() {
  const navigate = useNavigate();
  const submit = useServerFn(createSource);
  const qc = useQueryClient();
  const [submitting, setSubmitting] = useState(false);

  return (
    <SourceForm
      title="Neue Quelle"
      submitting={submitting}
      onSubmit={async (values) => {
        const parsed = sourceInputSchema.safeParse({
          ...values,
          caveat_de: values.caveat_de.trim() || null,
          caveat_en: values.caveat_en.trim() || null,
        });
        if (!parsed.success) {
          toast.error("Eingabe ungültig", { description: parsed.error.issues.map((i) => i.message).join("; ") });
          return;
        }
        setSubmitting(true);
        try {
          await submit({ data: parsed.data });
          toast.success("Quelle angelegt");
          qc.invalidateQueries({ queryKey: ["admin-sources"] });
          navigate({ to: "/admin/sources" });
        } catch (e) {
          toast.error("Speichern fehlgeschlagen", { description: e instanceof Error ? e.message : String(e) });
        } finally {
          setSubmitting(false);
        }
      }}
    />
  );
}
